import { ExperienceClassBookingProcess } from '../consts';
import { ExperienceClassBookingSteps } from '../types';

/**
 * 校验targetStep是否可以跳转
 */
const validateTargetSteps = (targetStep?: string | string[], currentStep?: string | string[] | string) => {
  const suportedTargetSteps = [
    ExperienceClassBookingSteps.ConfirmTeacher,
    ExperienceClassBookingSteps.FilterTeachers,
    ExperienceClassBookingSteps.FundamentalQuestionLearningTarget,
  ];
  // 可以跳转
  const canJump =
    typeof targetStep === 'string' && suportedTargetSteps.includes(targetStep as ExperienceClassBookingSteps);

  // 需要跳转
  const needJump =
    typeof currentStep !== 'string' ||
    (typeof currentStep === 'string' &&
      !ExperienceClassBookingProcess.includes(currentStep as ExperienceClassBookingSteps));

  return canJump && needJump;
};

export { validateTargetSteps };
